export default __webpack_public_path__ + "static/media/10.cea2a866.jpg";